import React from 'react';
import { Upload, Checkbox, Input, Button, Select, Radio, Space } from 'antd';
import styles from './style.module.scss';
import SpiceSelect from './spiceSelect';
import MenuService from '../../services/MenuService';

const AddItem = (props) => {
    const { setNewItem, newItem, menuDetails, submitForm, showAdd, settingsList, allIngredient, allCourses, allKdsStation } = props;
    const { TextArea } = Input;

    const onUpdateValue = (e, num) => {
        const newItemList = { ...newItem }
        if(num){
            newItemList[e.target.name] = parseInt(e.target.value);
        } else {
            newItemList[e.target.name] = e.target.value;
        }
        setNewItem(newItemList);
    };
    const onFooodTypeChange = (e) => {
        const newItemList = { ...newItem };
        newItemList[e.target.name] = e.target.checked;
        setNewItem(newItemList);
    };
    const onSpiceChange = (val) => {
        const newItemList = { ...newItem }
        newItemList.spice_level = val;
        setNewItem(newItemList);
    };
    const onSelectIngredient = (e, field) => {
        const newItemList = { ...newItem }
        newItemList[field] = e;
        setNewItem(newItemList);
    }
    const onRadioChange = (e) => {
        const newItemList = { ...newItem }
        newItemList.allow_spice_level = e.target.value;
        setNewItem(newItemList);
    };
    const uploadImage = async(options) =>{
        const { onSuccess, onError, file, onProgress } = options;
        const formData = new FormData();
        formData.append('file', file);
        const urlResponse = await MenuService.uploadMenuItemPhoto(formData);  
        const newItemList = { ...newItem }
        newItemList.photo_url = urlResponse?.url;
        setNewItem(newItemList);
        onSuccess(true);
    };
    return  <div className={styles.add_item}>
    <div className={styles.heading}>
        <div className={styles.head_text}>Item Details</div>
    </div>
    <div className={styles.sub_heading}>Add name and Description of the item.</div>
    <div className={styles.details_wrap}>
        <div className={styles.form_area}>
            <div className={styles.menu_item_wrap}>
                <label>Menu</label>
                <Input placeholder="Provide the menu name" name="menu"  disabled value={menuDetails.name} onChange={(e)=>{onUpdateValue(e)}}/>
            </div>
            <div className={styles.menu_item_wrap}>
                <label>Section</label>
                <Input placeholder="Provide the menu name" name="section" disabled value={showAdd.name}  onChange={(e)=>{onUpdateValue(e)}}/>
            </div>
            <div className={styles.menu_item_wrap}>
                <label>Course</label>
                <Select 
                    placeholder="Select Course here"
                    className='w-full normal_select_border'
                    options={allCourses.map((itm)=>({label:itm.name, value: itm.id}))} 
                    onChange={(e)=>{onSelectIngredient(e, 'meal_course_id')}}
                    value={newItem.meal_course_id}
                />
            </div>
            <div className={styles.menu_item_wrap}>
                <label>KDS Station</label>
                <Select 
                    placeholder="Select KDS Station here"
                    className='w-full normal_select_border'
                    options={allKdsStation.map((itm)=>({label:itm.name, value: itm.id}))} 
                    onChange={(e)=>{onSelectIngredient(e, 'kds_station_id')}}
                    value={newItem.kds_station_id}
                />
            </div>
            <div className={styles.menu_item_wrap}>
                <label>Name</label>
                <Input placeholder="Enter name here" name="name"  value={newItem.name} onChange={(e)=>{onUpdateValue(e)}}/>
            </div>
            <div className={styles.menu_item_wrap}>
                <label>Price</label>
                <Input placeholder="Type Here (Optional)" min="0" type="number" name="price"  value={newItem.price} onChange={(e)=>{onUpdateValue(e, 'num')}}/>
            </div>
            <div className={styles.menu_item_wrap}>
                <label>Min. order quantity</label>
                <Input placeholder="Type Here (Optional)" min="0" type="number" name="minimum_order_quantity"  value={newItem.minimum_order_quantity} onChange={(e)=>{onUpdateValue(e, 'num')}}/>
            </div>
            <div className={styles.menu_item_wrap}>
                <label>Max. order quantity</label>
                <Input placeholder="Type Here (Optional)" min="0" type="number" name="maximum_order_quantity"  value={newItem.maximum_order_quantity} onChange={(e)=>{onUpdateValue(e, 'num')}}/>
            </div>
            <div className={styles.menu_item_wrap}>
                <label>Preparation Time</label>
                <Input placeholder="Type Here (Optional)" min="0" type="number" name="prep_time_minutes"  value={newItem.prep_time_minutes} onChange={(e)=>{onUpdateValue(e, 'num')}}/>
            </div>
            <div className={styles.menu_item_wrap}>
                <label>Main Ingredients</label>
                <Select 
                    mode="tags"
                    placeholder="Select Ingredients here"
                    className='w-full normal_select_border'
                    options={allIngredient?.map((itm)=>({label:itm.name, value: itm.name}))} 
                    onChange={(e)=>{onSelectIngredient(e, 'ingredients')}}
                    value={newItem.ingredients}
                />
            </div>
            {/* <div className={styles.menu_item_wrap}>
                <label>Size</label>
                <Input placeholder="Type Here (Optional)" name="size"  value={newItem.size} onChange={(e)=>{onUpdateValue(e)}}/>
            </div> */}
            {settingsList.allow_calories &&
                <div className={styles.menu_item_wrap}>
                        <label>Calories</label>
                        <Input placeholder="Type Here (Optional)" min="0" type="number" name="calories"  value={newItem.calories} onChange={(e)=>{onUpdateValue(e, 'num')}}/>
                </div>}
            {settingsList.allow_description && 
                <div className={styles.menu_item_wrap}>
                    <label>Description</label>
                    <TextArea rows={3} placeholder="Type Description here" name="description"  value={newItem.description}  onChange={(e)=>{onUpdateValue(e)}}/>
            </div>}
            <div className={styles.img_area_wrap}>
                <div className={styles.upload_wrap}>
                    <label>Menu Item Image</label>
                    <div name="photo_url">
                            <Upload className={styles.upload_btn} fileList={[]} customRequest={uploadImage}>
                            {newItem.photo_url ?
                            <div className={styles.uploaded_img}>
                            <img
                            src={newItem.photo_url}
                            alt="avatar"
                            style={{
                                height: '100%',
                                objectFit: 'cover'
                            }}
                            /> 
                        </div> 
                        :
                            <div className={styles.menu_upload}>
                                    <div className={styles.upload_content}>
                                        <img src="/images/upload.png" alt="FoodLuv" />
                                        <p>Click or drag file to this area to upload</p>
                                    </div>
                                </div>}
                            </Upload>
                    </div>
                </div>
           </div>
            <div className={styles.food_type}>
                <label>Menu Items: </label>
                {settingsList.allow_nuts && <div className={styles.checkitem}><Checkbox checked={newItem.has_nuts} name="has_nuts" onClick={(e)=>{onFooodTypeChange(e)}}>Nuts</Checkbox> </div>}
                {settingsList.allow_dairy && <div className={styles.checkitem}><Checkbox checked={newItem.has_dairy} name="has_dairy" onClick={(e)=>{onFooodTypeChange(e)}}>Dairy</Checkbox> </div>}
                {settingsList.allow_vegan && <div className={styles.checkitem}><Checkbox checked={newItem.is_vegan} name="is_vegan" onClick={(e)=>{onFooodTypeChange(e)}}>Vegan</Checkbox> </div>}
                {settingsList.allow_vegetarian && <div className={styles.checkitem}><Checkbox checked={newItem.is_vegetarian} name="is_vegetarian" onClick={(e)=>{onFooodTypeChange(e)}}>Vegetarian</Checkbox> </div>}
                {settingsList.allow_gluten_free && <div className={styles.checkitem}><Checkbox checked={newItem.is_gluten_free} name="is_gluten_free" onClick={(e)=>{onFooodTypeChange(e)}}>Gluten Free</Checkbox> </div>}
            </div>
                    {/* {settingsList.allow_spice_level && 
                        <div className={styles.spicy_sec}>
                            <label>Spice</label>
                            {SpiceSelect(onSpiceChange, newItem.spice_level)}
                        </div>
                    } */}
           <div className={styles.spicelevel_sec}>
            <label>Allow customer to select spice level: </label>
            <div className={styles.radio_sec}>
                <Radio.Group onChange={onRadioChange} value={newItem.allow_spice_level}>
                    <Space direction="horizontal">
                        <Radio value={true}>Yes</Radio>
                        <Radio value={false}>No</Radio>
                    </Space>
                </Radio.Group>
            </div>
           </div>
        </div>
    </div>
    <div className={styles.btn_section}>
        <Button type="primary"  htmlType="submit" className={styles.submit_btn} onClick={()=>submitForm(false)}>
            Save
        </Button>
        <Button type="primary"  htmlType="submit" className={styles.submit_btn} onClick={()=>submitForm(true)}>
            Save & Customize
        </Button>
    </div>
</div>
};
export default AddItem;